// extracted by mini-css-extract-plugin
export default {"container":"y1-z","heading":"z1-z","links":"A1-z","copy":"B1-z","subCopy":"C1-z","linksLeft":"D1-z","linksCenter":"E1-z","linksRight":"F1-z","link":"G1-z","onlyLink":"H1-z"};